import React, { Component } from "react";
import classnames from "classnames";

import { HStack } from "@formant/ui/component/common/HStack";

import * as styles from "./Rating.scss";
import { StandardButton } from "./StandardButton";

export interface IRatingProps {
    onRate: (_: number) => void;
    value?: number;
}

export class Rating extends Component<IRatingProps> {
    public render() {
        const { value, onRate } = this.props;

        const elements = [];
        for (const _ of Array(5).keys()) {
            const rating = _ + 1;
            const setRating = () => onRate(rating);
            const active = value === rating;

            elements.push(
                <StandardButton
                    className={classnames(styles.item, active && styles.active)}
                    key={rating}
                    onClicked={setRating}
                >
                    {rating}
                </StandardButton>,
            );
        }

        return <HStack className={styles.items}>{elements}</HStack>;
    }
}
